<template>
    <div class="cantainer">
        <div class="header">
            <p class="top-txt">看见你的美好，<span class="defor">AI</span>视觉让每一帧都精彩！</p>
            <p class="txt-grap">已有超10,000,000用户通过AI视觉看到美牙后的自己。</p>
            <p style="text-align: center;"><el-button class="start">开启变美之旅</el-button></p>
        </div>
        <div class="ai-main">
            <ul class="plan">
                <li v-for="item in aiList">
                    <img class="ai-img" :src="item.url">
                    <p class="details"><span style="font-size: 28px;">AI</span>{{ item.title }}</p>
                    <p class="paragraph">{{ item.paragraph }}</p>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return {
            aiList:[
                {
                    title:' DSD美学规划',
                    url:'/static/images/AI_DSD.png',
                    paragraph:'口腔美学DSD设计是指通过口腔数字化方法，利用DSD（Digital Smile Design）技术，对患者的牙齿进行规划设计，以达到更美观和自然的效果。通过AI DSD使口腔美学治疗方案更加透明、可视化，具有实时修改和共同决策的优势，有助于患者更好地理解和接受治疗方案，获得最佳满意度。'
                },
                {
                    title:' ISD种植规划',
                    url:'/static/images/AI_ISD.png',
                    paragraph:'口腔种植AI ISD导航规划是一种先进的技术，可以在口腔种植手术中实现智能计划，规避种植手术风险，基于颅骨条件，输出合理方案以达到以修复为导向，兼顾美学和功能的种植修复。AI ISD通过对患者口腔的三维图像进行自动识别与分析，精确测量骨质和解剖标志，从而为种植手术提供更精准的规划，帮助医生更好地理解患者的口腔结构，预测植入物的最佳位置和方向，提高手术的成功率。'
                },
                {
                    title:' ORTHO正畸规划',
                    url:'/static/images/AI_ORTHO.png',
                    paragraph:'口腔AI正畸规划是指利用人工智能技术进行口腔正畸治疗方案的制定和优化。通过计算机视觉、深度学习等技术，对患者的口腔结构进行全面而精准的分析，为医生提供更科学、个性化的治疗建议。在正畸AI规划中，系统可通过对患者的口腔影像数据进行处理，识别出牙齿的位置、偏移和颌面骨骼的情况。借助机器学习算法，系统能够学习和识分别不同患者的口腔特征，并根据这些特征为每位患者制定个性化的矫正计划。AI ORTHO技术的优势在于提高了治疗的精准度和效率，减少了人为因素的影响。'
                },
            ]
        }
    }
}
</script>
<style scoped>
.cantainer{
    background-color: white;
}
.header{
    width: 100%;
}
.top-txt,.txt-grap{
    text-align: center;
}
.top-txt{
    color: black;
    font-size: 24px;
    font-weight: 550;
    letter-spacing: 2px;
    margin-top: 20px;
    margin-bottom: 10px;
}
.txt-grap{
    color: #7f8c8d;
    margin-bottom: 20px;
}
.start{
    color: white;
    border-radius: 10px;
    letter-spacing: 1px;
    background-color: #786FFE;
}
.ai-main{
    height: 700px;
    margin-top: 50px;
}
.plan{
    list-style-type: none;
}
.plan li {
     display: block;
     float: left;
}
.ai-img{
    width: 100%;
}
.plan li:nth-of-type(1){
    width: 18%;
    margin:3% 7% 0 13%;
    .paragraph{
        margin-top: 25%;
    }
}
.plan li:nth-of-type(2){
    width: 25%;
    margin:0 7% 0 0;
    .paragraph{
        margin-top: 8%;
    }
}
.plan li:nth-of-type(3){
    width: 20%;
    margin-top:3%;
    .paragraph{
        margin-top: 21%;
    }
}
.details{
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    line-height: 60px;
}
.details span{
    color: #0049FE;
}
.defor{
    font-family:Georgia, 'Times New Roman', Times, serif;
    /* color: red; */
}
</style>


// WEBPACK FOOTER //
// AI.vue?2283fa76